import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class LogService {
  private logStream: Subject<any>;
  public logs: Observable<LogMessage>;

  constructor() {
    // Create a new Subject and expose the stream as an Observable.
    this.logStream = new Subject();
    this.logs = this.logStream.asObservable();
  }

  public log(logMessage: LogMessage) {
    // Add the message to the log stream
    this.logStream.next(logMessage);
  }

  public error(message: string) {
    this.log(new LogMessage(LogLevel.ERROR, message));
  }

  public warn(message: string) {
    this.log(new LogMessage(LogLevel.WARN, message));
  }

  public info(message: string) {
    this.log(new LogMessage(LogLevel.INFO, message));
  }

  public debug(message: string) {
    this.log(new LogMessage(LogLevel.DEBUG, message));
  }

  public verbose(message: string) {
    this.log(new LogMessage(LogLevel.VERBOSE, message));
  }
}

export class BaseLogSubscriberService implements LogSubscriberInterface {
  public logs: Observable<LogMessage>;

  constructor(private logService: LogService) {
    this.logs = this.logService.logs;
  }

  public init(level?: LogLevel) {
    this.logs.subscribe(this.log.bind(this));
  }

  public log(message: LogMessage) {
    // No implementation
  }
}

export class FilteredLogSubscriberService extends BaseLogSubscriberService {
  constructor(ls: LogService) {
    super(ls);
  }

  public init(level: LogLevel) {
    // Filter the logs to include the specified log level
    this.logs = this.logs.filter(logMessage => logMessage.level <= level);
    super.init(level);
  }
}

export interface LogSubscriberInterface {
  logs: Observable<LogMessage>;
  init(level: LogLevel): void;
  log(message: LogMessage): void;
}

export class LogMessage {
  constructor(public level = LogLevel.INFO, public message = '') {
  }
}

export enum LogLevel {
  ERROR,
  WARN,
  INFO,
  DEBUG,
  VERBOSE
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/log/log.service.ts